import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { SalvTooltipWrapper } from '@salvapp/ui-components';
import React from 'react';
import { SalvTooltipWrapperProps } from '@salvapp/ui-components/build/SalvTooltipWrapper/SalvTooltipWrapper.types';
import { clsx } from 'clsx';
import './CommonTooltip.scss';

export const CommonTooltip = ({ tooltip, type }: Pick<SalvTooltipWrapperProps, 'tooltip'> & { type?: TooltipType }) => {
  const className = clsx('common-tooltip-wrapper', {
    information: type === TooltipType.INFO,
    warn: type === TooltipType.WARN,
  });

  const ariaLabel = type === TooltipType.INFO ? 'Information' : type === TooltipType.WARN ? 'Warning' : undefined;
  return (
    <SalvTooltipWrapper tooltip={tooltip} placement={'top'}>
      <FontAwesomeIcon icon={faCircleInfo} className={className} aria-label={ariaLabel} />
    </SalvTooltipWrapper>
  );
};

export enum TooltipType {
  INFO,
  WARN,
}
